import React, { useEffect, useState } from "react";

// JS Files
import CoversCard from "./CoversCard";

// Others File
import cover1 from "../../imgs/cover-1.svg";
import cover2 from "../../imgs/cover-2.svg";
import cover3 from "../../imgs/cover-3.svg";
import cover4 from "../../imgs/cover-4.svg";
import cover5 from "../../imgs/cover-5.svg";
import cover6 from "../../imgs/cover-6.svg";
import cover7 from "../../imgs/cover-7.svg";
import useFetch from "../../context/useFetch";
import { toast } from "react-toastify";

const Covers = () => {
  const [dataList, setDataList] = useState({ results: [] });
  const getCverList = useFetch({
    method: "get",
    url: `Coverage_Service`,
    trigger: true,
    noHeader: true,

    setter: setDataList,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const get_title = (ti) => {
    if (ti == "darman") return "بیمه‌های درمان تکمیلی";
    if (ti == "daneshamooz") return "حوادث دانش‌آموزی";
    if (ti == "atashsoozi") return "بیمه منازل مسکونی فرهنگیان";
    if (ti == "mohandesi") return "بیمه مهندسی";
    if (ti == "omr") return "بیمه عمر";
    if (ti == "khodro") return "بیمه‌های خودرو";
    if (ti == "masouliat") return "بیمه مسئولیت";
  };
  const get_cover = (ti) => {
    if (ti == "darman") return cover1;
    if (ti == "daneshamooz") return cover2;
    if (ti == "atashsoozi") return cover3;
    if (ti == "omr") return cover4;
    if (ti == "mohandesi") return cover7;
    if (ti == "khodro") return cover5;
    if (ti == "masouliat") return cover6;
  };
  return (
    <>
      <div className="mx-4 md:mx-16 mb-2 mt-10 md:mt-20">
        <p className="header">پوشش بیمه نامه</p>
      </div>
      <div className="grid md:grid-cols-3 gap-4 md:gap-8 mt-8  px-8 md:px-20 py-8 bg-myblue-500">
        {dataList.results.map((item, index) => {
          return [
            <CoversCard
              attach_file={item.attach_file}
              icon={get_cover(item.field)}
              header={get_title(item.field)}
            />,
          ];
        })}
      </div>
    </>
  );
};
export default Covers;
